<template>
  <div class="metals">
    <div
        v-for="(metal, index) in props.metals"
        :key="index"
    >
        <div
            class="metals-block"
            :style="{background: metal.color}"
        >
          <div class="metals-tableName">
            {{metal.tableName}}
          </div>
          <div class="metals-block-weight">
            {{metal.weight}} г
          </div>
          <div class="metals-block-text">
            <span>{{metal.name}}</span><br/>
            <span>{{metal.percent}} %</span>
          </div>
          <div class="metals-block-price" v-if="metal.price && metal.price !== '0.00'">
            {{formatPrice(metal.price)}} ₽
          </div>
        </div>
    </div>
  </div>
</template>


<script setup>
import { defineProps } from 'vue'
import { formatPrice } from '@/helpers/helpers'

const props = defineProps({
  metals: {
    type: Array,
    default: () => []
  }
})

</script>

<style lang="scss" scoped>
.metals {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-around;
  //overflow-y: scroll;
  margin-top: 20px;
  height: 300px;
  padding-bottom: 10px;
  &-item {
    position: relative;
  }
  &-block {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 15vh;
    width: 15vh;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.18);
    font-weight: 600;
    margin-bottom: 40px;
    text-align: center;
    transition: opacity 0.5s;
    color: white;
    //overflow: hidden;
    &-text {
      color: white;
      position: absolute;
      top: 16vh;
      left: 0;
      right: 0;
      width: 100%;
      white-space: normal;
      text-align: center;
      font-size: 12px;
      z-index: 5;
    }
    &-price {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 92%;
      background-color: rgba(248, 239, 239, 0.18);
      color: white;
      padding: 6px 4px;
      font-size: 11px;
      font-weight: 600;
      text-align: center;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
  &-tableName {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.2);
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}
</style>
